// extracted by mini-css-extract-plugin
module.exports = {"widgetContainer":"styles_widgetContainer__3fl7F","widgetImage":"styles_widgetImage__1McTV","imageOverlay":"styles_imageOverlay__1BDUK","title":"styles_title__ZDyPO"};